// Copy pozostaje w Light DOM: komponent nie pobiera i nie zastępuje treści.
let panelSequence = 0
const styles = `
ct-trip-plan.ct-trip-plan { display:block; width:100%; max-width:1200px; margin:0 auto; color:#404040; }
ct-trip-plan.ct-trip-plan, ct-trip-plan.ct-trip-plan * { box-sizing:border-box; }
ct-trip-plan.ct-trip-plan > article { margin:0 0 16px; padding:24px 28px; background:#fff; border:1px solid #f1e4d3; border-radius:12px; box-shadow:0 2px 6px rgba(0,0,0,.06); }
ct-trip-plan.ct-trip-plan > article:last-child { margin-bottom:0; }
ct-trip-plan.ct-trip-plan h3 { margin:0; font:500 20px/1.45 Poppins,Arial,sans-serif; color:inherit; }
ct-trip-plan.ct-trip-plan h3 .day-number { color:#f7931e; font-size:15px; letter-spacing:.04em; }
ct-trip-plan.ct-trip-plan .day-toggle { display:flex; align-items:center; justify-content:space-between; gap:20px; width:100%; padding:0; border:0; border-radius:4px; background:none; color:inherit; font:inherit; text-align:left; cursor:pointer; }
ct-trip-plan.ct-trip-plan .day-toggle:focus-visible { outline:3px solid #18586a; outline-offset:6px; }
ct-trip-plan.ct-trip-plan .day-toggle:hover .day-chevron { background:#fff2e2; }
ct-trip-plan.ct-trip-plan .day-chevron { display:flex; flex:0 0 36px; width:36px; height:36px; align-items:center; justify-content:center; border:1px solid #f7931e; border-radius:50%; color:#f7931e; transition:background 160ms; }
ct-trip-plan.ct-trip-plan .day-chevron svg { width:18px; height:18px; transition:transform 160ms; }
ct-trip-plan.ct-trip-plan .day-toggle[aria-expanded="true"] svg { transform:rotate(180deg); }
ct-trip-plan.ct-trip-plan p, ct-trip-plan.ct-trip-plan li { font:400 18px/28px Georgia,'Times New Roman',serif; }
ct-trip-plan.ct-trip-plan > article > p { margin:14px 0 0; padding-top:12px; border-top:1px solid #f1e4d3; }
ct-trip-plan.ct-trip-plan .day-details { margin-top:16px; }
ct-trip-plan.ct-trip-plan .day-details[hidden] { display:none !important; }
ct-trip-plan.ct-trip-plan .day-details p { margin:0 0 12px; }
ct-trip-plan.ct-trip-plan .day-details ul { display:block; margin:0; padding:0 0 0 22px; list-style:disc outside; }
ct-trip-plan.ct-trip-plan .day-details li { display:list-item; margin:0; padding:0; list-style:disc outside; }
ct-trip-plan.ct-trip-plan .day-details li + li { margin-top:6px; }
ct-trip-plan.ct-trip-plan strong { font-weight:700; }
@media(min-width:768px) and (max-width:1199px) {
  ct-trip-plan.ct-trip-plan p, ct-trip-plan.ct-trip-plan li { font-size:17px; line-height:26px; }
}
@media(max-width:767px) {
  ct-trip-plan.ct-trip-plan { width:94vw; max-width:none; position:relative; left:50%; transform:translateX(-50%); margin-left:0; margin-right:0; }
  ct-trip-plan.ct-trip-plan > article { padding:18px; margin-bottom:12px; }
  ct-trip-plan.ct-trip-plan h3 { font-size:17px; line-height:1.4; }
  ct-trip-plan.ct-trip-plan h3 .day-number { font-size:13px; }
  ct-trip-plan.ct-trip-plan .day-toggle { gap:12px; min-height:44px; }
  ct-trip-plan.ct-trip-plan .day-chevron { flex-basis:32px; width:32px; height:32px; }
  ct-trip-plan.ct-trip-plan p, ct-trip-plan.ct-trip-plan li { font-size:16px; line-height:24px; }
  ct-trip-plan.ct-trip-plan > article > p { margin-top:12px; padding-top:10px; }
}
@media(prefers-reduced-motion:reduce) { ct-trip-plan.ct-trip-plan .day-chevron, ct-trip-plan.ct-trip-plan .day-chevron svg { transition:none; } }
@media print { ct-trip-plan.ct-trip-plan .day-details[hidden] { display:block !important; } ct-trip-plan.ct-trip-plan .day-chevron { display:none; } ct-trip-plan.ct-trip-plan > article { break-inside:avoid; box-shadow:none; } }
`

export class CtTripPlan extends HTMLElement {
  static observedAttributes = ['open-day']

  constructor() {
    super()
    this.cards = new Map()
    this.handleClick = event => {
      const button = event.target.closest?.('.day-toggle')
      if (!button || button.closest('ct-trip-plan') !== this) return
      const card = button.closest('article')
      const entry = this.cards.get(card)
      if (entry) this.setExpanded(entry, button.getAttribute('aria-expanded') !== 'true', true)
    }
    this.observer = new MutationObserver(() => this.initializeCards())
  }

  connectedCallback() {
    this.classList.add('ct-trip-plan')
    if (!document.getElementById('ct-trip-plan-styles')) {
      const style = document.createElement('style')
      style.id = 'ct-trip-plan-styles'
      style.textContent = styles
      document.head.append(style)
    }
    this.addEventListener('click', this.handleClick)
    this.initializeCards()
    // Obsługuje również element zdefiniowany przed zakończeniem parsowania HTML.
    this.observer.observe(this, { childList: true, subtree: true })
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick)
    this.observer.disconnect()
    for (const entry of this.cards.values()) {
      this.setExpanded(entry, entry.button.getAttribute('aria-expanded') === 'true')
    }
  }

  attributeChangedCallback() {
    if (!this.isConnected) return
    this.initializeCards()
    Array.from(this.cards.values()).forEach((entry, index) => {
      this.setExpanded(entry, this.initiallyOpen(index))
    })
  }

  initiallyOpen(index) {
    const setting = this.getAttribute('open-day') ?? '1'
    return setting === 'all' || Number(setting) === index + 1
  }

  initializeCards() {
    for (const [card] of this.cards) {
      if (card.parentElement !== this) this.cards.delete(card)
    }
    Array.from(this.children).filter(el => el.matches('article')).forEach((card, index) => {
      if (this.cards.has(card)) return
      const heading = card.querySelector(':scope > h3')
      const panel = card.querySelector(':scope > .day-details')
      if (!heading || !panel) return
      let button = heading.querySelector('.day-toggle')
      if (!button) {
        button = document.createElement('button')
        button.type = 'button'
        button.className = 'day-toggle'
        const title = document.createElement('span')
        title.append(...heading.childNodes)
        const icon = document.createElement('span')
        icon.className = 'day-chevron'
        icon.setAttribute('aria-hidden', 'true')
        icon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>'
        button.append(title, icon)
        heading.append(button)
      }
      if (!panel.id) panel.id = `ct-day-details-${++panelSequence}`
      button.setAttribute('aria-controls', panel.id)
      const entry = { button, panel }
      this.cards.set(card, entry)
      this.setExpanded(entry, this.initiallyOpen(index))
    })
  }

  setExpanded(entry, expanded, animate = false) {
    const { button, panel } = entry
    const currentHeight = panel.hidden ? 0 : panel.getBoundingClientRect().height
    const currentStyle = getComputedStyle(panel)
    const currentMargin = panel.hidden ? 0 : parseFloat(currentStyle.marginTop)
    const currentOpacity = panel.hidden ? 0 : Number(currentStyle.opacity)
    entry.animation?.cancel()
    entry.animation = null
    button.setAttribute('aria-expanded', String(expanded))
    panel.inert = !expanded
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (!animate || reducedMotion || !panel.animate) {
      panel.hidden = !expanded
      panel.style.removeProperty('overflow')
      return
    }

    // Mierzymy bieżącą klatkę również przy szybkim odwróceniu animacji.
    // Wysokość i górny odstęp zmieniają rzeczywisty układ, nie tylko obraz karty.
    panel.hidden = false
    panel.style.overflow = 'hidden'
    const fullHeight = panel.scrollHeight
    const fullMargin = parseFloat(getComputedStyle(panel).marginTop)
    const animation = panel.animate([
      { height: `${currentHeight}px`, marginTop: `${currentMargin}px`, opacity: currentOpacity },
      { height: `${expanded ? fullHeight : 0}px`, marginTop: `${expanded ? fullMargin : 0}px`, opacity: expanded ? 1 : 0 },
    ], {
      duration: 260,
      easing: 'cubic-bezier(0.2, 0, 0, 1)',
      fill: 'both',
    })
    entry.animation = animation
    animation.finished.then(() => {
      if (entry.animation !== animation) return
      panel.hidden = !expanded
      panel.style.removeProperty('overflow')
      entry.animation = null
      animation.cancel() // Po otwarciu wracamy do naturalnej wysokości tekstu.
    }).catch(() => {}) // Odwrócenie albo usunięcie karty przerywa poprzednią animację.
  }
}

if (!customElements.get('ct-trip-plan')) customElements.define('ct-trip-plan', CtTripPlan)
